<div class="cat-dd-wrap">
  <span class="dd-title">
    <span>{{ 'common.text21' | craftTerm }}:</span>
    @if (portal.categoryMandatory) {
      <span class="red text-size-18">*</span>
    }
  </span>
  @if (ups.allowCreateCategory) {
    <craft-categories-autocomplete
      [selectedId]="categoryId"
      [newCategoryId]="newCategoryId"
      (enterPressed)="onEnter($event)"
      (select)="updateValue($event)"
      class="autocomplete ellipsis"
    ></craft-categories-autocomplete>
  } @else {
    <craft-categories-select [selectedId]="categoryId" (select)="updateValue($event)"></craft-categories-select>
  }
</div>
